import { render, staticRenderFns } from "./FinalizarCompra.vue?vue&type=template&id=6ddad657"
import script from "./FinalizarCompra.vue?vue&type=script&lang=js"
export * from "./FinalizarCompra.vue?vue&type=script&lang=js"
import style0 from "./FinalizarCompra.vue?vue&type=style&index=0&id=6ddad657&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports